// ANCHOR React
import React, { memo } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';

// ANCHOR Utils
import { formatCountLabel } from '@lyon/utils/extras/formatCountLabel';

// ANCHOR Components
import { CategoryTag } from '@lyon/components/utils/CategoryTag';
import { LyonCourseCardTitle } from './LyonCourseCardTitle';
import { LyonCourseCardProvider } from './LyonCourseCardProvider';

// ANCHOR Styles
import { BLOCK, HEADER_TAGS, HEADER_TAG } from './styles';

export const LyonCourseCardBody = memo(() => {
  const moduleCount = CourseCardData.useSelector((state) => state.data?.moduleCount);

  return (
    <Block overrides={BLOCK}>
      <LyonCourseCardTitle />
      <LyonCourseCardProvider />
      <Block overrides={HEADER_TAGS}>
        {
          !!moduleCount && (
            <CategoryTag
              overrides={HEADER_TAG}
              label={`${formatCountLabel(moduleCount, 'module')}`}
            />
          )
        }
      </Block>
    </Block>
  );
});
